import  './RentIdPage.css';
import GuestVerification from '../GuestVerification/GuestVerification';
import VerificationDashboard from '../VerificationDashboard/VerificationDashboard';
import Safety from '../Safety/Safety';
import NationalScroll from '../NationalScroll/NationalScroll';

const RentIdPage = ()=>{


    return(
        <>
            {/* START bannerInnerMain */}
            <section className="bannerInnerMain bannerIdMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="bannerPageInner">
                                <figure><img src="/img/RentID/rentId_icon_banner.svg" alt="banner"/></figure>
                                <h1>Trust and Safety tools to help outsmart risky rentals </h1>
                                <p>Screen renters, verify insurance, and detect fraud in seconds, while giving you the control to approve bookings with confidence.</p>
                                {/* <div className="bannerBtn">
                                    <a href="#" className="btn">
                                    <span>Watch Video</span>
                                    <img width="16px" src="/img/video_play.svg" alt="Watch Video"/>
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerInnerMain */}

            {/* START riskManagementMain */}
            <section className='riskManagementMain' id='RealtimeGuestVerification'>
                <div className='container'>
                    <div className='row align-items-center'>
                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                    <div className='riskManagementText'>
                        <h6>RISK ASSESSMENT AND VETTING TOOLS</h6>
                        <h2>Manage renter risk & protect your fleet</h2>
                        <p>Prevent high-risk bookings with advanced screening, real-time insurance validation, and fraud detection, leveraging data driven insights for smarter rental decisions.</p>
                        <ul>
                            <li>
                            <a href="#RealtimeGuestVerification">
                                <img width="24px" height="24px"src="/img/rentid_icon_1.svg" alt="rentid"/>
                                Realtime Guest Verification 
                            </a>
                            </li>
                            <li>
                            <a href="#AutoInsuranceValidation">
                                <img width="24px" height="24px"src="/img/shield-energy.svg" alt="rentid"/>
                                Auto Insurance Validation
                            </a>
                            </li>
                            <li>
                            <a href="#DriverIQScore">
                                <img width="24px" height="24px"src="/img/math.svg" alt="rentid"/>
                                DriverIQ Score
                            </a>
                            </li>
                            <li>
                            <a href="#NationalBlockListDatabase">
                                <img width="24px" height="24px"src="/img/do-not-touch.svg" alt="rentid"/>
                                National BlockList Database
                            </a>
                            </li>
                            <li>
                            <a href="#VerificationDashboard">
                                <img width="24px" height="24px"src="/img/computer-check.svg" alt="rentid"/>
                                Verification Dashboard
                            </a>
                            </li>
                            <li>
                            <a href="#RiskManagement">
                                <img width="24px" height="24px"src="/img/settings.svg" alt="rentid"/>
                                Risk Management
                            </a>
                            </li>
                        </ul>
                    </div>
                </div>
                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                        <div className="riskManagementRight">
                        <div className="riskManagementImage">
                            <figure>
                            <img className="img-fluid" src="/img/RentID/risk-management.webp" alt="liablity"/>
                            </figure>
                            {/* <figure>
                            <img className="img-fluid" src="/img/risk-management.png" alt="liablity"/>
                            </figure>
                            <img className="img-fluid renter_risk_back" src="/img/renter_risk_back_1.png" alt="liablity"/>
                            <div className="riskProtect">
                            <div className="auto-insurance">
                                <img src="/img/featured-img1.svg" alt="liablity"/>
                                <div className="inner-text-sec">
                                <h5>Build Trust and Loyalty</h5>
                                <p>Create a book of great rental customers.</p>
                                </div>
                            </div>
                            <div className="auto-insurance left-space-box">
                                <img src="/img/featured-img1.svg" alt="liablity"/>
                                <div className="inner-text-sec">
                                <h5>Enhance Rental Operations</h5>
                                <p>Accept or decline bookings based on risk profile.</p>
                                </div>
                            </div>
                            <div className="auto-insurance left-space-box1">
                                <img src="/img/featured-img1.svg" alt="liablity"/>
                                <div className="inner-text-sec">
                                <h5>Optimize Business Risk Management</h5>
                                <p>Earn, grow, and thrive with data-driven decisions.</p>
                                </div>
                            </div>
                            </div> */}

                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
            {/* END riskManagementMain */}
 
            {/* START loyalGuest */}
            <section className='loyalGuest'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 text-center'>
                            <div className='guestHeading'>
                                <h2>From First-Time Renter to <span>Loyal Guest.</span></h2>
                                <p>We’ve taken the guess work out of building trust, protecting your fleet and optimizing 
                                earnings with automated rental risk assessment tools. </p>
                                <div className='loyalGuestImg'>
                                    <img className="img-fluid" src="/img/RentID/loyal-guest-new.png" alt="guest"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END loyalGuest */}

            <GuestVerification />


            {/* START autoInsuranceMain */}
            <section className='autoInsuranceMain' id='AutoInsuranceValidation'>
                <div className='container'>
                    <div className='row justify-content-center'>
                    <div className="col-md-12">
                    <div className="autoInsuranceHeading">
                        <figure>
                        <img className="img-fluid" width="48px" height="48px" src="/img/shield_energy_white.svg" alt="icon"/>
                    </figure>
                    <div className="autoInsuranceText">
                        <h2>Auto Insurance Validation</h2>
                        <p>Verify guest coverages instantly and gain insights needed to protect your rental fleet.</p>
                        </div>
                    </div>
                    </div>
                    </div>

                    <div className='row'>
                        <div className="col-xl-3 col-lg-4">
                            <div className="autoInsuranceLeft">
                            {/* <img className="img-fluid" src="/img/autoInsuranceLeft.png" alt="icon"/> */}
                            <video width="300"   controls="false" loop autoPlay muted playsInline>
                                <source src="/img/RentID/autoInsuranceLeft.mp4" type="video/mp4" />
                            </video>
                            </div>
                        </div>


                        <div className="col-xl-9 col-lg-8">
                            <div className="autoInsuranceRight">
                            <div className='row'>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/policy_status_verification.svg" alt="icon"/>
                                        </figure>
                                        <h3>Policy Status<br/> Verification</h3>
                                        <p>Instantly check status of a renter's insurance policy to confirm  validity.</p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/RentID/umbrella.svg" alt="icon"/>
                                        </figure>
                                        <h3>Coverage Level <br/>Confirmation</h3>
                                        <p>Ensure that insurance coverage meets or exceeds rental requirements.</p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/RentID/monitoring.svg" alt="icon"/>
                                        </figure>
                                        <h3>Expiration <br/>Monitoring</h3>
                                        <p>Track expiration dates to prevent rentals with outdated coverage.</p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/RentID/edit_user.svg" alt="icon"/>
                                        </figure>
                                        <h3>Claims<br/> History</h3>
                                        <p>Review the renter’s insurance claims history to assess risk levels.</p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/RentID/building.svg" alt="icon"/>
                                        </figure>
                                        <h3>Carrier<br/> Validation</h3>
                                        <p>Verify insurance provider is reputable and recognized within the industry.</p>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                        <div className="autoInsuranceInner">
                                        <figure>
                                            <img className="img-fluid" width="36px" height="36px" src="/img/RentID/coverage_adequacy.svg" alt="icon"/>
                                        </figure>
                                        <h3>Coverage<br/> Adequacy</h3>
                                        <p>Confirm that the insurance provides sufficient protection the rental.</p>
                                        </div>
                                    </div>

                            </div>
                            </div>
                        </div>



                    </div>
                </div>
            </section>

            {/* END autoInsuranceMain */}

            {/* START driverIqMain */}
            <section className='driverIqMain' id='DriverIQScore'>
                <div className="driverIqLeft">
                    <ul>
                        <li className='rentalHistory'>
                            <img src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Rental History</span>
                        </li>
                        <li className='behavioralAnalysis'>
                            <img src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Behavioral Analysis</span>
                        </li>

                        <li className='paymentReliability'>
                            <img  src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Payment Reliability</span>
                        </li>
                        <li className='violationTracking'>
                            <img src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Violation Tracking</span>
                        </li>

                        <li className='claimsHistory'>
                            <img  src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Claims History </span>
                        </li>
                        <li className='riskFactor'>
                            <img src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Risk Factor Assessment</span>
                        </li>

                        <li className='realTimeScoring'>
                            <img  src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Real-Time Scoring</span>
                        </li>
                        <li className='patternRecognition'>
                            <img  src="/img/RentID/check_white.svg" alt="bg"/>
                            <span>Pattern Recognition</span>
                        </li>
                    </ul>
                </div>
                <img className="driverIq_bg" src="/img/RentID/driverIq_bg_2.png" alt="bg"/>
                    <div className='container'>
                        <div className='row driverIqOuter'>
                            <div className="col-xl-6 col-lg-12 col-md-12">
                            <div className="driverIqRight">
                                <figure>
                                <img className="img-fluid" width="48px" height="48px" src="/img/RentID/driver-iq.svg" alt="icon"/>
                            </figure>
                                <h2>DriverIQ™ Risk Scoring</h2>
                                <h3>Data-Driven Risk Assessment</h3>
                                <p>Make informed rental decisions with DriverIQ™, our proprietary risk scoring system tailored for car rental operators. 
                                Each rental generates actionable insights, 
                                enhanced by host community-sourced feedback and scoring to validate renters and assess risks with confidence.</p>
                                <img className="driverIq_RightImage" src="/img/RentID/driverIq_Right_2.webp" alt="Diver IQ"/>
                                <img className="driverIq_RightImage_Mobile" src="/img/RentID/driverIq_Right_2_mobile.png" alt="Diver IQ"/>
                            </div>
                            </div>
                        </div>
                    </div>
            </section>
            {/* END driverIqMain */}

            <NationalScroll/>



             <VerificationDashboard />

            {/* START timelineMain */}
            <section className="timelineMain" id='RiskManagement'>
                <img className="timeline_2" src="/img/RentID/timeline_2.png" alt="Risk Management"/>
                <div className="container">
                    <div className="timelineOuter">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-xl-8 col-lg-11 col-md-12 col-sm-12">
                                    <div className="timeHeading justify-content-center align-items-start">
                                        <figure><img className="img-fluid" width="48px" height="48px" src="/img/RentID/setting_icon.svg" alt="icon"/></figure>
                                        <div className="commonText">
                                            <h2>Risk Management & Decision Support</h2>
                                            <p>Empower your business to make confident rental decisions and approvals with our integrated risk management and support tools.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="timeline">
                                <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="timelineLeft">
                                                <div className="timelineInner">
                                                    <figure><img className="img-fluid" src="/img/RentID/time_1.webp" alt="Risk Notifications"/></figure>
                                                    <div className="timelineInnerData">
                                                        <span>01</span>
                                                        <h3>Risk Notifications</h3>
                                                        <p>Receive real-time alerts when a potential renter matches criteria on the DNR List.</p>
                                                    </div>
                                                </div>
                                                <div className="timelineInner">
                                                    <figure><img className="img-fluid" src="/img/RentID/time_3.webp" alt="Custom Rule Settings"/></figure>
                                                    <div className="timelineInnerData">
                                                        <span>03</span>
                                                        <h3>Custom Rule Settings</h3>
                                                        <p>Define and adjust rules to align with your operational policies and risk tolerance.</p>
                                                    </div>
                                                </div>

                                                <div className="timelineInner">
                                                <figure><img className="img-fluid" src="/img/RentID/time_5.webp" alt="Decision Logging"/></figure>
                                                <div className="timelineInnerData">
                                                    <span>05</span>
                                                    <h3>Decision Logging</h3>
                                                    <p>Keep a detailed record of all rental decisions for accountability and auditing purposes.</p>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="timelineRight">
                                                <div className="timelineInner">
                                                    <figure><img className="img-fluid" src="/img/RentID/time_2.webp" alt="Automated Recommendations"/></figure>
                                                    <div className="timelineInnerData">
                                                        <span>02</span>
                                                        <h3>Automated Recommendations</h3>
                                                        <p>Receive system-generated suggestions based on comprehensive data analysis.</p>
                                                    </div>
                                                </div>
                                            <div className="timelineInner">
                                                <figure><img className="img-fluid" src="/img/RentID/time_4.webp" alt="Override Options"/></figure>
                                                <div className="timelineInnerData">
                                                    <span>04</span>
                                                    <h3>Override Options</h3>
                                                    <p>Allow authorized personnel to override automated decisions when necessary.</p>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
            {/* END timelineMain */}

            <Safety />


            {/* START moreSolutionMain */}
            <section className='moreSolutionMain'>
                <div className='container'>
                        <div className="row">
                            <div className="col-lg-8 col-md-12 col-sm-12">
                                <div className="moreSolutionHeading">
                                    <h2>Discover more solutions</h2>
                                    <p>Rental tools to help you scale your business</p>
                                </div>
                            </div>
                        </div>

                        <div className='moreSolutionOuter'>
                            <div className="moreSolutionInner moreSolutionGreen">
                                <a href="/rentdirect">
                                <div className="green_overlay"></div>
                                    <figure><img src="/img/rent_direct_logo.svg" alt="logo"/></figure>
                                </a>
                            </div>

                            <div className="moreSolutionInner moreSolutionRed">
                                <a href="/rentshield">
                                    <div className="red_overlay"></div>
                                    <figure><img src="/img/rent_shield_logo.svg" alt="logo"/></figure>
                                </a>
                            </div>

                            <div className="moreSolutionInner moreSolutionwhite">
                                <a href="/rentai">
                                    <div className="white_overlay"></div>
                                    <figure> <img src="/img/rent_ai_logo.svg" alt="logo"/></figure>
                                </a>
                            </div>

                            <div className="moreSolutionInner moreSolutionPurple">
                                <a href="/rentsuccess">
                                    <div className="purple_overlay"></div>
                                    <figure><img src="/img/rent_success_logo.svg" alt="logo"/></figure>
                                </a>
                            </div>
                            
                            <div className="moreSolutionInner moreSolutionYellow">
                                <a href="/rentacademy">
                                    <div className="yellow_overlay"></div>
                                    <figure> <img src="/img/rent_academy_logo.svg" alt="logo"/></figure>
                                </a>
                            </div>
                        </div>
                </div>
            </section>
            {/* START moreSolutionMain */}
        </>
    )
}

export default RentIdPage;